export const ruleGridItemFrag = `
        resource
        action
`;

export const groupGridItemFrag = `
      id
      name
      children
      organizationId
      rules {
        ${ruleGridItemFrag}
      }
`;
